import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getSellerList, getOnlineShopAreaList, deleteOnlineShopArea, onlineShopAreaUpdate, getGoodsCategoryList } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';

var _this;

export default {
  name: 'OnlineShopCategoryManage',
  filters: {
    formatDate: function formatDate(time, format) {
      if (time != null && time !== '') {
        return formatTimeToStr(time, format || 'yyyy-MM-dd hh:mm:ss');
      }

      return '';
    },
    getSellerName: function getSellerName(id) {
      for (var i = 0; i < _this.sellerOptions.length; i++) {
        if (_this.sellerOptions[i].sellerId == id) {
          return _this.sellerOptions[i].sellerName;
        }
      }

      return '';
    },
    getCategoryName: function getCategoryName(categoryNo) {
      for (var i = 0; i < _this.categoryOptions.length; i++) {
        if (_this.categoryOptions[i].categoryNo == categoryNo) {
          return _this.categoryOptions[i].name;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getOnlineShopAreaList,
      tableData: [],
      type: '',
      sellerOptions: [],
      categoryOptions: [],
      formData: {}
    };
  },
  computed: {},
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var sellerOptions, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.formData = _this3.initData();
                _context3.next = 3;
                return getSellerList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 3:
                sellerOptions = _context3.sent;
                _this3.sellerOptions = sellerOptions.data.list;
                _this3.searchInfo.sellerId = _this3.sellerOptions[0].sellerId;
                _this3.searchInfo.dataType = 2;
                _context3.next = 9;
                return getGoodsCategoryList({
                  'parentNo': 0
                });

              case 9:
                res = _context3.sent;
                _this3.categoryOptions = res.data.list;
                _context3.next = 13;
                return _this3.getTableData();

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      return {};
    },
    onSearch: function onSearch() {
      this.page = 1;
      this.pageSize = 10;
      this.searchInfo.dataType = 2;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {
        sellerId: this.sellerOptions[0].sellerId,
        dataType: 2
      };
      this.onSearch();
    },
    onClose: function onClose() {
      this.formData = this.initData();
    },
    onAdd: function onAdd() {
      this.$router.push({
        name: 'OnlineShopAddCategory',
        query: {},
        params: {
          meta: {
            title: '新增二级类目'
          },
          gobackParam: {
            isGoback: true,
            activeName: 'OnlineShopCategoryManage'
          },
          action: 'add'
        }
      });
    },
    onUpdate: function onUpdate(row) {
      this.$router.push({
        name: 'OnlineShopAddCategory',
        query: {},
        params: {
          meta: {
            title: '变更二级类目'
          },
          gobackParam: {
            isGoback: true,
            activeName: 'OnlineShopCategoryManage'
          },
          action: 'update',
          showAreaNo: row.showAreaNo
        }
      });
    },
    onUpdateStatus: function onUpdateStatus(row, status) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return onlineShopAreaUpdate({
                  'showAreaNo': row.showAreaNo,
                  'isChangeStatus': 1,
                  'showAreaStatus': status
                });

              case 2:
                _this4.getTableData();

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onDelete: function onDelete(row) {
      var _this5 = this;

      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return deleteOnlineShopArea({
                  'showAreaNo': row.showAreaNo
                });

              case 2:
                _this5.getTableData();

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))).catch(function (err) {});
    }
  }
};